import { FW_SHARE_PARAM, FW_SHARE_VALUES } from '@core/sharing/constants'

const VALID_SHARE_TYPES = new Set<string>(Object.values(FW_SHARE_VALUES))

type FWShareType = (typeof FW_SHARE_VALUES)[keyof typeof FW_SHARE_VALUES]

/** Returns true when value is a known share type (`ds` or `sv`). */
export const isValidShareType = (
  value: string | undefined | null,
): value is FWShareType => !!value && VALID_SHARE_TYPES.has(value)

/**
 * Parses and validates `fw_share` from a URL's query string or hash fragment.
 * Returns undefined for missing or unknown values.
 */
export const parseShareTypeFromUrl = (url: string): string | undefined => {
  try {
    const u = new URL(url)
    const value =
      u.searchParams.get(FW_SHARE_PARAM) ??
      new URLSearchParams(u.hash.replace(/^#/, '')).get(FW_SHARE_PARAM)
    return isValidShareType(value) ? value : undefined
  } catch {
    return undefined
  }
}
